import React, { useState, useEffect } from "react";
import cx from "classnames";
import { Option } from "react-select/lib/filters";
import { useParams } from "react-router-dom";
import { useApolloClient } from "@apollo/client";
import { Select } from "@foris/avocado-suite";
import { contractTypeQuery } from "../graphql/instructor.queries";
import { IParams } from "@models/IParams";
import { ISelectorReturn, IOption } from "./ISelectors";
import { InstructorContractType, DataQuery } from "@models/ISchema";
import css from "./selectors.module.scss";

interface ContractTypeSelectProps extends ISelectorReturn {
  contractTypeOption?: Option;
}

const ContractTypeSelect: React.FC<ContractTypeSelectProps> = (props: ContractTypeSelectProps) => {
  const client = useApolloClient();
  const { onCallback, label, className, placeholder, contractTypeOption } = props;
  const { scenario }: IParams = useParams();
  const [optionsContract, setOptionsContract] = useState<IOption[]>([]);
  const [valueContract, setValueContract] = useState(contractTypeOption);

  const getContractOptions = async () => {
    try {
      const response = await client.query({
        query: contractTypeQuery,
        variables: { scenarioId: scenario },
      });
      const dataQuery: DataQuery = response?.data?.data;
      const optContractType =
        dataQuery?.instructorContractTypes?.items?.map((contractType: InstructorContractType) => ({
          label: `${contractType.code} - ${contractType.name}`,
          value: contractType.id,
        })) ?? [];
      setOptionsContract(optContractType);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (optionsContract.length === 0) {
      getContractOptions();
    }
  });

  return (
    <div className={cx(css.selectors, className)}>
      <Select
        label={label}
        options={optionsContract}
        placeholder={placeholder}
        isClearable
        value={valueContract}
        onChange={(value: IOption) => {
          if (value) {
            setValueContract(value as Option);
            onCallback(value);
          } else {
            setValueContract(null);
            onCallback(value);
          }
        }}
      />
    </div>
  );
};

export default ContractTypeSelect;
